import React, { useCallback, useEffect, useMemo } from 'react';
import { SmlsButton, SmlsHeaderPlaceholder } from '@smiles/smiles-ui-kit-react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { loginDataLayer } from 'utils/dataLayer';
import waitContactImage from '../../assets/wait-contact.svg';

type HistoryState = {
  memberStatus?: string;
};

const SuccessRecoverUser: React.FC = () => {
  const { t } = useTranslation('success_email_sent');
  const location = useLocation();
  const memberStatus = useMemo(() => {
    const { state } = location;
    const historyState = state as HistoryState;
    if (!historyState) return '';
    return historyState.memberStatus;
  }, [location]);

  const inactiveUserSubPage = useMemo(() => loginDataLayer.inactiveUserSubPage(memberStatus), [memberStatus]);

  const redirectToHome = useCallback(() => {
    window.location.href = `${window.location.origin}/home?upd=${new Date().getTime()}`;
  }, []);

  useEffect(() => {
    loginDataLayer.triggerPageViewEvent(`${inactiveUserSubPage}/aguardar-contato`, 2);
  }, []);

  return (
    <div className="success-email-send-wrapper">
      <SmlsHeaderPlaceholder redirectUrl={window.location.origin} />
      <div className="success-email-send">
        <img src={waitContactImage} alt="orange email symbol" />
        <div>
          <h3>{t('title')}</h3>
          <p>
            <Trans t={t} i18nKey="subtitle" components={{ bold: <b /> }} />
          </p>
          <SmlsButton text={t('button')} onClick={redirectToHome} color="primary" />
        </div>
      </div>
    </div>
  );
};

export default SuccessRecoverUser;
